<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Usuarios</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-btn color="primary" dark class="mb-2" v-on:click="nuevoRegistro()">Nuevo usuario</v-btn>
    <v-dialog v-model="dialog" max-width="400px">
      <v-tabs v-model="tabActivo">
        <v-tab><b>Usuario</b></v-tab>
        <v-tab v-bind:disabled="disabledSede"><b>Sedes</b></v-tab>
        <v-tab v-bind:disabled="disabledSede"><b>Permisos</b></v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-md>
                  <v-layout wrap>
                  <v-flex d-flex>
                    <v-layout align-center>
                      <v-text-field label="Usuario" v-model="registro.usuario" :rules="requeridoRegla" v-bind:readonly="disabledRegistro"></v-text-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex d-flex>
                    <v-layout align-center>
                      <v-text-field label="Clave" v-model="registro.clave" v-bind:readonly="disabledRegistro"></v-text-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex d-flex>
                    <v-layout align-center>
                      <v-select name="estado" id="estado" :items="estados" v-model="registro.estado" item-text="nombre" item-value="id" return-object v-bind:readonly="disabledRegistro"/>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-on:click="nuevoRegistro()" v-if="disabledRegistro">Nuevo</v-btn>
              <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro">Editar</v-btn>
              <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
              <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout align-center v-for="acceso in registro.accesos" :key="acceso[0]">
                  <v-checkbox :label="`${acceso.nombre}`" v-model="acceso.acceso" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-on:click="nuevoRegistro()" v-if="disabledRegistro">Nuevo</v-btn>
              <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro">Editar</v-btn>
              <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
              <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout align-center>
                  <v-checkbox label="Administrador" v-model="registro.permisos.administrador" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Usuarios" v-model="registro.permisos.usuarios" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Sedes" v-model="registro.permisos.sedes" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Configuración" v-model="registro.permisos.configuracion" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Colegios" v-model="registro.permisos.colegios" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Inscritos" v-model="registro.permisos.inscritos" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Verificar pagos" v-model="registro.permisos.verificarPagos" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Resultados" v-model="registro.permisos.resultados" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Reportes" v-model="registro.permisos.reportes" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox label="Modificar resultados" v-model="registro.permisos.modificarResultados" v-bind:readonly="disabledRegistro"></v-checkbox>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro">Editar</v-btn>
              <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
              <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ estados2[props.item.fila[2]] }}</td>
      <td align="center">
        <v-icon
          v-if="props.item.fila[0] !== 0"
          @click="verRegistro(props.item)"
        >
          open_in_browser
        </v-icon>
      </td>
    </template>
    <template slot="no-data">
      -
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    tabActivo: 0,
    dialog: false,
    disabledSede: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [
      { text: 'Usuario', value: 0 },
      { text: 'Estado', value: 1 },
      { text: '', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    sedes: [],
    registro: {permisos: {}},
    estados: [{id: 'A', nombre: 'Activo'}, {id: 'I', nombre: 'Inactivo'}],
    estados2: {'A': 'Activo', 'I': 'Inactivo'}
  }),
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=usuarios&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=usuarios&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
              this.disabledSede = false
            } else {
              this.disabledRegistro = false
              this.disabledSede = true
            }
            this.dialog = true
          }
        })
    },
    editarRegistro (item) {
      this.disabledSede = false
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=usuarios&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.disabledRegistro = false
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.tabActivo = 0
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar () {
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=usuarios&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro({fila: [datos.d.id]})
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue